import charsRemainView from './charsRemainComponent.html';
import './charsRemainComponent.css';
import _ from 'lodash';

export function charsRemainComponent() {
	return {
		bindings: {
			warnAt: '<?',
			limit: '<',
			offsetX: '<?',
			offsetY: '<?',
		},
		controllerAs: 'vm',
		transclude: true,
		controller: charsRemainComponentCtrl,
		template: charsRemainView,
	};
}

export class charsRemainComponentCtrl {
	constructor($element, $timeout) {
		'ngInject';
		// save injections
		this.$element = $element;
		this.$timeout = $timeout;
		if (this.warnAt == 'never') {
			// never warn, only show error
			this.warnAt = this.limit;
		} else if (!this.warnAt) {
			// default warnAt to 90% of limit
			this.warnAt = Math.floor(this.limit * 0.9);
		}
	}

	$postLink() {
		// find the editable element
		this.input = this.$element[0].querySelector('textarea, input, [contenteditable=true]');
		if (!this.input) {
			console.warn('WARNING: <sh-chars-remain> found no input, textarea or contenteditable.');
			return;
		}
		this.defaultOffsetX = 0;
		if (this.input.contentEditable === 'true') {
			this.type = 'contenteditable';
			this.defaultOffsetY = -21;
		} else if (this.input.tagName.toUpperCase() == 'TEXTAREA') {
			this.type = 'textarea';
			this.defaultOffsetY = -17;
		} else {
			this.type = 'input';
			this.defaultOffsetY = -17;
		}
		// bind handlers to ourself
		const opts = { leading: true, trailing: true };
		this.onInputChange = _.throttle(this.onInputChange.bind(this), 67, opts);
		this.onFocus = _.throttle(this.onFocus.bind(this), 67, opts);
		this.onBlur = _.throttle(this.onBlur.bind(this), 67, opts);
		// set up
		this._setupListeners();
		this._setOffset();
	}

	_setupListeners() {
		if (this.input.contentEditable === 'true') {
			this.observer = new MutationObserver(this.onInputChange);
			this.observer.observe(this.input, {
				childList: true,
				characterData: true,
				subtree: true,
			});
		} else {
			angular.element(this.input).on('input', this.onInputChange);
		}
		angular.element(this.input).on('focus', this.onFocus).on('blur', this.onBlur);
	}

	_setOffset() {
		this.offsetY = _.isNumber(this.offsetY) ? this.offsetY : this.defaultOffsetY;
		this.offsetX = _.isNumber(this.offsetX) ? this.offsetX : this.defaultOffsetX;
	}

	$onDestroy() {
		if (!this.input) {
			return;
		}
		if (this.input.contentEditable === 'true') {
			this.observer.disconnect();
			this.observer = undefined;
		} else {
			angular.element(this.input).off('input', this.onInputChange);
		}
		angular.element(this.input).off('focus', this.onFocus).off('blur', this.onBlur);
	}

	onInputChange() {
		this.textLength = 0;
		if (this.input.contentEditable === 'true') {
			this.textLength = this.input.innerHTML.length;
		} else if (this.input && this.input.value) {
			this.textLength = this.input.value.length;
		}
		this.$timeout(() => {});
	}

	onFocus() {
		this.isFocused = true;
		this.onInputChange();
	}

	onBlur() {
		this.isFocused = false;
		this.$timeout(() => {});
	}
}
